:host {
      /**
    * @prop --spinner-default-color: customize spinner main background-color.
    * @prop --spinner-default-bg-color: customize spinner secondary background-color.
    * @prop --spinner-size: customize spinner size.
    */
    --spinner-default-color: var(--joy-color-secondary-50);
    --spinner-default-bg-color: var(--joy-color-secondary-10);
    --spinner-size: 25px;

    width: var(--spinner-size);
    height: var(--spinner-size);
    box-sizing: border-box;
}

.joy-spinner {
    box-sizing: border-box;
    border-top: 3px solid var(--spinner-default-bg-color);
    border-right: 3px solid var(--spinner-default-bg-color);
    border-bottom: 3px solid var(--spinner-default-bg-color);
    border-left: 3px solid var(--spinner-default-color);

    $_size: 20;

    position: absolute;
    margin: auto;
    font-size: 10px;
    text-indent: -9999em;
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;

    &,
    &:after {
        border-radius: 50%;
        width: var(--spinner-size);
        height: var(--spinner-size);
    }

    @-webkit-keyframes load8 {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes load8 {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}

.joy-spinner_white {
    --spinner-default-color: #ffffff;
    --spinner-default-bg-color: rgba(255, 255, 255, 0.2);
}